import { render, staticRenderFns } from "./tabNav.vue?vue&type=template&id=f99fd938&scoped=true&"
import script from "./tabNav.vue?vue&type=script&lang=js&"
export * from "./tabNav.vue?vue&type=script&lang=js&"
import style0 from "./tabNav.vue?vue&type=style&index=0&id=f99fd938&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f99fd938",
  null
  
)

export default component.exports